<template>
  <z-dialog :show="isVisible" :modalSize="modalSize">
    <template v-slot:header>
      <h4 class="modal-title">
        {{ title }}
      </h4>
      <button type="button" class="btn-close" @click="close"></button>
    </template>
    <template v-slot:body>
      <z-tabs
        v-model="currentTab"
        :tabs="tabs"
        :badges="badges"
        @change="showTab"
      />
      <!-- Message -->
      <div v-show="currentTab === 'Message'" class="row custom-tab">
        <div class="col">
          <z-textarea
            v-model="text"
            name="text"
            label="Message"
            :rows="5"
            :maxlength="10000"
            @keyup="isSave = true"
          />
        </div>
      </div>
      <!-- Attachments -->
      <div v-show="currentTab === 'Attachments'" class="row custom-tab">
        <div class="col">
          <file-upload
            ref="fileUploader"
            title=""
            subtitle=""
            instructions="Drag your files (in png, or jpg format) here to begin or click to browse"
            :endpoint="endpoint"
            :id="orgId"
            :path="path"
            :folder="folder"
            :accept="accept"
            :key="uploadKey"
            :isShowSave="false"
            :isDontSave="true"
            :isShowList="true"
            :isReadonly="isEdit"
            :allowRemovalExisting="true"
            :existingFiles="existingFiles"
            @filesRemoved="filesRemoved"
            @filesAdded="filesAttached"
          />
        </div>
      </div>
      <!-- Images Here -->
    </template>
    <template v-slot:footer>
      <div class="row custom-footer">
        <div class="col-md-1"></div>
        <div class="col-md-6">
          <span v-if="invalidMessage !== ''" class="custom-invalid">{{
            invalidMessage
          }}</span>
        </div>
        <div class="col-md-5">
          <div class="custom-buttons">
            <button
              v-show="isSave"
              class="btn btn-primary me-2"
              :disabled="isSaving"
              @click="performSave()"
            >
              <i v-if="isSaving" class="fas fa-spinner fa-spin"></i>
              Save
            </button>
            <button type="button" class="btn btn-secondary me-2" @click="close">
              Cancel
            </button>
          </div>
        </div>
      </div>
    </template>
  </z-dialog>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import ZDialog from '@/Components/ZElements/Dialog'
import ZTextarea from '@/Components/ZElements/TextArea'
import FileUpload from '@/Components/ZElements/Upload'
import ZTabs from '@/Components/ZElements/Tabs'
export default {
  name: 'feed-dialog',
  components: {
    ZDialog,
    ZTextarea,
    FileUpload,
    ZTabs,
  },
  props: {
    show: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      modalSize: 'modal-lg',
      isSave: false,
      currentTab: 'Message',
      invalidMessage: null,
      validErrors: [],
      badges: [
        {
          name: 'Attachments',
          count: 0,
        },
      ],
      existingFiles: [],
      endpoint: '',
      uploadKey: 0,
      folder: '',
      path: '',
      accept: 'image/*',
      isSaving: false,
    }
  },
  mounted() {
    this.init()
  },
  computed: {
    ...mapGetters('users', ['profile']),
    ...mapGetters('feed', ['feedPost']),
    ...mapGetters('organizations', ['examineOrganization']),
    isVisible() {
      return this.show !== null
    },
    title() {
      let _title = ''
      if (this.show) {
        if (this.show.isAdd) {
          _title = 'New Wellness Wall Post'
        } else {
          _title = 'Edit Wellness Wall Post'
        }
      }
      return _title
    },
    tabs() {
      let _tabs = ['Message', 'Attachments']
      return _tabs
    },
    orgId() {
      let _data = null
      if (this.examineOrganization) {
        _data = this.examineOrganization.id
      }
      return _data
    },
    text: {
      get() {
        let _data = null
        if (this.feedPost) {
          _data = this.feedPost.text
        }
        return _data
      },
      set(value) {
        let data = {
          name: 'text',
          value: value,
        }
        this.setFeedPostData(data)
      },
    },
    isEdit() {
      let _data = false
      // if (this.feedPost) {
      //   if (this.feedPost.id !== null) {
      //     _data = true
      //   }
      // }
      return _data
    },
  },
  methods: {
    ...mapActions('feed', ['setFeedPostData', 'saveFeedPost', 'editFeedPost']),
    init() {
      this.isSaving = false
      this.invalidMessage = ''
      this.currentTab = 'Message'
      this.badges = [
        {
          name: 'Attachments',
          count: 0,
        },
      ]
      this.existingFiles = []
    },
    showTab(value) {
      this.currentTab = value
    },
    close() {
      this.$emit('close')
    },
    getFilename(uri) {
      let segments = uri.split('/')
      return segments[segments.length - 1]
    },
    setAttachments() {
      this.init()
      if (this.feedPost) {
        if (this.feedPost.images) {
          if (this.feedPost.images.length > 0) {
            this.existingFiles = []
            this.feedPost.images.forEach((element) => {
              if (element.Uri !== '') {
                // let segments = element.Uri.split('/')
                // let filename = segments[segments.length - 1]
                let filename = this.getFilename(element.Uri)
                this.existingFiles.push({
                  name: filename,
                  url: element.Uri,
                })
              }
            })
            this.badges[0].count = this.existingFiles.length
          }
        }
        // this.$nextTick(() => {
        //   this.$forceUpdate()
        // })
        setTimeout(() => {
          this.badges[0].count = this.existingFiles.length
        }, 250)
      }
    },
    attach() {
      console.log('Attaching File')
    },
    filesAttached(numfiles) {
      this.badges[0].count = numfiles
      this.isSave = true
    },
    filesRemoved(numfiles) {
      this.badges[0].count = numfiles
      this.isSave = true
    },
    getAttachedFiles() {
      return this.$refs.fileUploader.getAttachedFiles()
    },
    validate() {
      let valid = true
      this.validErrors = []
      this.invalidMessage = ''
      if (this.feedPost.text === '') {
        valid = false
        this.validErrors.push('message')
      }
      return valid
    },
    async performSave() {
      this.invalidMessage = ''
      this.validErrors = []
      let success = false
      let valid = this.validate()
      if (valid) {
        this.isSaving = true
        // Save Here
        let base64files = await this.$refs.fileUploader.getAttachedFilesBase64()
        let currentFiles = this.$refs.fileUploader.getExistingFiles()
        console.log('Save Feed post', {
          post: this.feedPost,
          base64files: base64files,
          existingFiles: currentFiles,
        })
        let results = null
        if (this.feedPost.id !== null) {
          // set up Post
          let post = {
            id: this.feedPost.id,
            text: this.feedPost.text,
            add_images: [],
            delete_images: [],
          }
          // add files
          if (base64files.length > 0) {
            base64files.forEach((file) => {
              post.add_images.push({
                FileName: file.name,
                base64Content: file.base64,
              })
            })
          }
          // remove files
          if (this.existingFiles.length !== currentFiles.length) {
            let removeImages = this.existingFiles.filter(
              (o) => !currentFiles.some((x) => x.name === o.name)
            )
            removeImages.forEach((element) => {
              post.delete_images.push(element.url)
            })
          }
          // save
          console.log('Save Edit Post', post)
          results = await this.editFeedPost(post)
        } else {
          // add files
          base64files.forEach((file) => {
            let data = {
              name: 'images',
              value: {
                FileName: file.name,
                base64Content: file.base64,
              },
            }
            this.setFeedPostData(data)
          })
          console.log('Save Add Post', this.feedPost)
          results = await this.saveFeedPost(this.feedPost)
        }
        this.isSaving = false
        console.log('Saved Feed Results', results)
        if (results) {
          if (results.error) {
            this.invalidMessage = results.error
          } else {
            success = true
            this.isSave = false
            this.$emit('saved')
          }
        }
      } else {
        alert('Please provide a post message.')
      }
      return success
    },
  },
}
</script>
<style lang="scss" scoped>
.custom-header {
  width: 100%;
}
.custom-body {
  max-height: 650px;
  overflow-x: hidden;
  overflow-y: scroll;
}
.custom-footer {
  width: 100%;
  text-align: left;
}
.custom-invalid {
  color: red;
  font-weight: 500;
}
.custom-buttons {
  position: relative;
  float: right;
}
</style>
